var _rect, _path, _rect2, _rect3, _rect4, _rect5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompoundV3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_573_18923)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.48245 15.4379C7.16218 15.2505 6.96631 14.9168 6.96631 14.5584V12.5572C6.96631 12.4806 6.98775 12.4068 7.02779 12.3411C7.15218 12.1359 7.42812 12.0662 7.64258 12.1865L12.3637 14.8196C12.6396 14.9742 12.8097 15.256 12.8097 15.5624V17.636C12.8097 17.7304 12.7825 17.8248 12.7311 17.9055C12.5752 18.149 12.2435 18.2256 11.989 18.0765L7.48245 15.4379ZM14.5197 11.638C14.7956 11.7926 14.9658 12.0744 14.9658 12.3807V16.5882C14.9658 16.7127 14.8957 16.8276 14.7828 16.8878L13.749 17.4446C13.7362 17.4514 13.7219 17.4569 13.7076 17.461V15.1247C13.7076 14.8224 13.5417 14.542 13.2701 14.386L9.12381 12.0128V9.37557C9.12381 9.29897 9.14526 9.22511 9.18529 9.15945C9.30967 8.95427 9.58562 8.88451 9.80008 9.00488L14.5197 11.638ZM16.5857 8.53024C16.8631 8.68344 17.0332 8.96795 17.0332 9.27435V15.4201C17.0332 15.546 16.9603 15.6622 16.8445 15.7224L15.8651 16.2285V11.9499C15.8651 11.6476 15.6993 11.3685 15.429 11.2126L11.1912 8.78056V6.27875C11.1912 6.20215 11.2127 6.12829 11.2513 6.06263C11.3757 5.85745 11.6516 5.78769 11.8661 5.90669L16.5857 8.53024Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 12,
    height: 12,
    rx: 6,
    fill: "url(#paint1_linear_573_18923)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 15,
    width: 1,
    height: 6,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 15,
    width: 1,
    height: 6,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 15,
    width: 1,
    height: 6,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_573_18923",
    x1: 24,
    y1: 0.306306,
    x2: 24,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D395"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A776"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_573_18923",
    x1: 18,
    y1: 12,
    x2: 18,
    y2: 23.1429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A242B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompoundV3);
export default __webpack_public_path__ + "static/media/compound-v3.3a7f71f4927d4cf6cdac74d4685058e7.svg";
export { ForwardRef as ReactComponent };